import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircle,
  faArrowCircleRight,
  faCircleNotch,
} from '@fortawesome/free-solid-svg-icons';

import JobMobileDetailsModal from './JobMobileDetailsModal';

const STATUS_DISPLAY_MAP = new Map([
  [
    'COMPLETED',
    { text: 'Complete', icon: faCircle, colorClass: 'alert-confirmation' },
  ],
  ['FAILED', { text: 'Failed', icon: faCircle, colorClass: 'active-dm' }],
  [
    'MESSAGE_SENT',
    {
      text: 'Message Sent',
      icon: faCircleNotch,
      colorClass: 'in-progress-yellow',
    },
  ],
  [
    'RUNNING',
    {
      text: 'Running',
      icon: faCircleNotch,
      colorClass: 'in-progress-yellow',
    },
  ],
  [
    'PENDING',
    { text: 'Pending', icon: faArrowCircleRight, colorClass: 'text-dark' },
  ],
]);

export default function JobMobileCard({ job }) {
  const [showDetailsModal, toggleDetailsModal] = useState(false);
  const { text, icon, colorClass } = STATUS_DISPLAY_MAP.get(job?.status) || {};
  const border =
    job?.status === 'PENDING'
      ? 'border-background-gray'
      : `border-${colorClass}`;
  return (
    <div className={`card col-12 mb-3 d-md-none border ${border}`}>
      <div className="card-body">
        <h6 className="text-gray">{job?.jobName}</h6>
        <div
          className={`d-flex align-items-center three-quarter-text text-${colorClass}`}
        >
          {icon ? <FontAwesomeIcon icon={icon} size="xs" /> : null}
          <span className="ml-2">{text}</span>
        </div>
        <div className="mt-3 d-flex align-items-center justify-content-center">
          <button
            className="btn btn-outline-third-gray rounded-pill three-quarter-text px-5 py-0"
            onClick={() => toggleDetailsModal(!showDetailsModal)}
          >
            <span className="text-text-gray">Details</span>
          </button>
        </div>
      </div>
      <JobMobileDetailsModal
        isOpen={showDetailsModal}
        toggleModal={toggleDetailsModal}
        job={job}
      />
      <style jsx>{`
        .card {
          border-width: medium !important;
        }
      `}</style>
    </div>
  );
}

JobMobileCard.propTypes = {
  job: PropTypes.shape({
    commandId: PropTypes.string,
    createdAt: PropTypes.string,
    email: PropTypes.string,
    gatewayId: PropTypes.string,
    jobCommand: PropTypes.string,
    jobMessage: PropTypes.string,
    jobName: PropTypes.string,
    status: PropTypes.oneOf([
      'COMPLETED',
      'FAILED',
      'MESSAGE_SENT',
      'RUNNING',
      'PENDING',
    ]),
    templateId: PropTypes.string,
    updatedAt: PropTypes.string,
  }),
};
